import React from "react";
import styled from "styled-components";

// hooks
import { useInPageSearchIsHidden } from "../useInPageSearchIsHidden";

// components
import CoreSearchBar from "../../index";
import DropDownAndInput from "../../components/DropDownAndInput";
import { InputStyled } from "../../components/Input";
import SearchButton from "../../components/SearchButton";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";
const IconPhotoSearchBarWrapperStyled = styled.div`
    margin: 0px auto;

    @media (min-width: ${breakpoints.tablet.rem}) {
        margin: 0px;
        max-width: ${convertPxToRem(295)};
    }
`;

const SearchBarStyled = styled(CoreSearchBar)`
    height: ${convertPxToRem(48)};
`;

const DropDownAndInputStyled = styled(DropDownAndInput)`
    height: ${convertPxToRem(48)};

    ${InputStyled} {
        @media (min-width: ${breakpoints.tablet.rem}) {
            padding: ${convertPxToRem(19)} ${convertPxToRem(14)};
        }
    }
`;

const SearchButtonStyled = styled(SearchButton)`
    flex: 0 0 ${convertPxToRem(48)};
`;

// component
export const SearchBar = () => {
    const { inPageSearchIsHidden, searchBarRef } = useInPageSearchIsHidden();

    return (
        <IconPhotoSearchBarWrapperStyled ref={searchBarRef}>
            <SearchBarStyled
                isDarkMode={true}
                isDisabled={inPageSearchIsHidden}
                id="icon-photo-search"
            >
                <DropDownAndInputStyled showFormSelectDialog={false} />
                <SearchButtonStyled showText={false} iconSize={20} />
            </SearchBarStyled>
        </IconPhotoSearchBarWrapperStyled>
    );
};

export default SearchBar;
